import Footer from './Footer';
import Header from './Header';
import Disclaimer from './Disclaimer';
import TermsOfUse from './TermsOfUse';
import Message from './Message';

export {
  Message,
  Footer,
  Header,
  Disclaimer,
  TermsOfUse
};
